import React, { lazy, Suspense } from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import Button from 'components/UI/Button';
import { useStateModal } from 'utils/hooks';

import * as styles from './Content.module.scss';

const RequestConsultation = lazy(() => import('components/Modals/RequestConsultation'));

export default function Content({ title, subtitle, button, titleMod, numberOfIcons, size, modal }) {
  const { modalState, showModal, hideModal } = useStateModal();

  return (
    <div className={styles.container}>
      <Title
        tag="h1"
        size={size !== 'lg' ? 'h1Secondary' : 'h1'}
        color="white"
        className={cn(
          styles.title,
          iconsClassName(numberOfIcons),
          titleMod && styles[titleMod],
          size !== 'lg' && styles.smallerTitle,
        )}
      >
        {title}
      </Title>
      {subtitle && (
        <Subtitle tag="p" size="lg" color="white" className={styles.subtitle}>
          {subtitle}
        </Subtitle>
      )}
      {button && (
        <>
          <Button fullWidthMobile className={styles.button} onClick={button.handle || showModal}>
            {button.text}
          </Button>
          <Suspense fallback={null}>
            <RequestConsultation
              title={modal?.title ?? button.text}
              isOpen={modalState.isOpen}
              closeModalCallback={hideModal}
              id="header"
              formName={modal?.formName ?? 'header'}
              commentPlaceholder={modal?.commentPlaceholder}
              commentPlaceholderMessage={modal?.commentPlaceholderMessage}
              withAttach={modal?.withAttach}
              modalAsideData={modal?.aside}
            />
          </Suspense>
        </>
      )}
    </div>
  );
}

function iconsClassName(numberOfIcons) {
  switch (numberOfIcons) {
    case 1: {
      return styles.oneIcon;
    }
    case 2: {
      return styles.twoIcons;
    }
    case 3: {
      return styles.threeIcons;
    }
    default:
      return;
  }
}
